import { forwardRef } from 'react';
import { Link as RadixLink } from '@radix-ui/themes';
import type { RadixLinkProps } from '@/types/radix-ui';

/**
 * Link component - wrapper around Radix UI Link
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type LinkProps = RadixLinkProps;

const Link = forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => {
  return <RadixLink ref={ref} {...props} />;
});

Link.displayName = 'Link';

export { Link };
